// extracted by mini-css-extract-plugin
module.exports =  {"main":"---src-components-Shared-VPAutocompleteDropdown__main--ptdOi"};